import { ClientLabel } from 'labels/client'

import { cx } from 'utils/cx'
import {
	type AITextMessage,
	type AgentTextMessage,
	MessageRole,
	type QuestionMessage,
} from '../../types/messageTypes'
import styles from './PlainMessage.module.scss'

export const PlainMessage = ({
	message,
}: {
	readonly message: QuestionMessage | AITextMessage | AgentTextMessage
}) => (
	<p
		className={cx(
			styles.message,
			message.role === MessageRole.Human
				? styles.leftMargin
				: styles.rightMargin
		)}
	>
		<ClientLabel>{message.value}</ClientLabel>
	</p>
)
